<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 求职意向 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">求职意向</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="期望工作地" prop="workingPlace">
                <el-cascader
                  style="width: 100%"
                  filterable
                  clearable
                  :options="options"
                  v-model="selectedOptions"
                  @change="addressChoose"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="期望职位" prop="jobPosition">
                <el-cascader
                  style="width: 100%"
                  filterable
                  clearable
                  :options="classDataTree"
                  v-model="TreeOptions"
                  @change="TreeChoose"
                  ref="cascader_Ref"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="薪酬类型" prop="hopeSalaryType">
                <el-select
                  v-model="form.hopeSalaryType"
                  placeholder="请选择薪酬类型"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in salaryType"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="期望薪资(滑块两个值都为0是，为面议)"
                prop="hopeSalary"
              >
                <el-slider
                  v-model="hopeSalary"
                  range
                  :max="100"
                  :marks="marks"
                  style="margin-top: 50px"
                  @change="getHopeSalary"
                >
                </el-slider>
              </el-form-item>
              <el-form-item label="求职状态" prop="jobSeeking">
                <el-select
                  v-model="form.jobSeeking"
                  placeholder="请选择求职状态"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in jobStatus"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import { personalInfo, reTradeList, personalInfoCommit } from "@/api/index";
import {
  pcaTextArr, // 省市区三级联动数据，纯汉字
} from "element-china-area-data";
import { Debounce, handleTree } from "@/helper/utilities.js";
export default {
  name: "resume-intention",
  data() {
    return {
      jobStatus: [
        "正在找工作-随时到岗",
        "在职-暂无跳槽打算",
        "在职-正考虑换工作",
        "在职-有更好的机会也可以考虑",
      ],
      salaryType: ["月薪", "年薪"],
      options: pcaTextArr, // 省市区三级联数据，纯汉字
      selectedOptions: [],
      classDataTree: [], //行业
      TreeOptions: [],
      hopeSalary: [0, 100],
      marks: {
        0: {
          style: {
            color: "#1989FA",
          },
          label: this.$createElement("strong", "面议"),
        },
        92: {
          style: {
            color: "#1989FA",
          },
          label: this.$createElement("strong", "单位(k)"),
        },
      },
      form: {
        workingPlace: undefined,
        tradeId: undefined,
        jobPosition: undefined,
        hopeSalaryType: undefined,
        hopeSalary: "面议",
        jobSeeking: undefined,
      },
      rules: {
        jobPosition: [
          { required: true, message: "期望职位不能为空", trigger: "change" },
        ],
        hopeSalaryType: [
          { required: true, message: "薪酬类型不能为空", trigger: "change" },
        ],
        hopeSalary: [
          { required: true, message: "期望薪资不能为空", trigger: "blur" },
        ],
        jobSeeking: [
          { required: true, message: "求职状态不能为空", trigger: "change" },
        ],
        workingPlace: [
          { required: true, message: "期望工作地不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getreTradeList();
    this.getPersonalInfo();
  },
  methods: {
    getPersonalInfo() {
      personalInfo()
        .then((res) => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              if (!res.data.reMiniProgramPerson.hasOwnProperty("hopeSalary")) {
                this.$set(res.data.reMiniProgramPerson, "hopeSalary", "面议");
              } 
              this.form = res.data.reMiniProgramPerson;
              this.selectedOptions =
                res.data.reMiniProgramPerson.workingPlace.split("-");
              if (res.data.reMiniProgramPerson.hopeSalary == "面议") {
                this.hopeSalary = [0, 0];
              } else {
                let array = res.data.reMiniProgramPerson.hopeSalary.split("-");
                let arr = [];
                array.forEach((item) => {
                  arr.push(this.removeSpaces(item));
                });
                this.hopeSalary = arr;
              }
              let sumArr = [];
              this.findParent(
                this.classDataTree,
                res.data.reMiniProgramPerson.tradeId,
                sumArr
              );
              this.TreeOptions = sumArr.reverse();
            }
          }
        })
        .catch((err) => {});
    },

    //通过子级找父级
    findParent(list, id, arr) {
      for (let item of list) {
        if (item.value == id) {
          arr.push(item.value); //要id就push item.id, 要对象就push item
          return true;
        }
        if (item.children && item.children.length > 0) {
          let isFind = this.findParent(item.children, id, arr);
          if (isFind) {
            arr.push(item.value); //要id就push item.id, 要对象就push item
            return true;
          }
        }
      }
      return false;
    },

    // 去除字母
    removeSpaces(str) {
      return str.replace(/[a-zA-Z]/g, "");
    },

    //获取行业
    getreTradeList() {
      reTradeList().then((res) => {
        res.data.shift();
        let list = handleTree(res.data, "tradeId", "parentId");
        this.classDataTree = this.changeListFiled(list);
      });
    },

    changeListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach((t) => {
          let newItem = {
            label: t.tradeName,
            value: t.tradeId,
            children: t.children,
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeListFiled(t.children);
          }
        });
      }
      return newList;
    },

    addressChoose(value) {
      if (value.length > 0) {
        this.form.workingPlace = value[0] + "-" + value[1] + "-" + value[2];
        this.selectedOptions = value;
      } else {
        this.form.workingPlace = "";
      }
    },

    TreeChoose(value) {
      if (value.length > 0) {
        this.form.tradeId = value[2];
        this.form.jobPosition = this.$refs.cascader_Ref
          .getCheckedNodes()[0]
          .pathLabels.join(" / ");
      } else {
        this.form.tradeId = "";
        this.form.jobPosition = "";
      }
    },

    getHopeSalary(value) {
      if (value[0] == 0 && value[1] == 0) {
        this.form.hopeSalary = "面议";
      } else {
        this.form.hopeSalary = value[0] + "k" + "-" + value[1] + "k";
      }
    },

    submit: Debounce(function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          personalInfoCommit(this.form).then((res) => {
            if (res.code == 200) {
              this.$router.go(-1);
              this.$message({
                showClose: true,
                message: "保存成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "warning",
              });
            }
          });
        }
      });
    }, 1000),
  },
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
